<template>
    <div class="user">
        <Modal
            v-model="showDelModal"
            :title="$t('confirm')+$t('lock')"
            @on-ok="showDelModal=false;lockUser(userIdToDel);"
            @on-cancel="showDelModal=false"
        >
            <p>{{$t('confirmDel')}}</p>
        </Modal>

        <div class="search">
            <Input v-model="search" :placeholder="$t('searchTips')+'...'" style="width:200px;"></Input>
            <Button type="primary" @click="loadData(currentPage)">{{$t('searchText')}}</Button>
            <Button type="primary" class="add_user" icon="md-add" @click="show_add_user = true">{{$t('add')}}{{$t('user')}}</Button>
        </div>
        <Table border :columns="columns12" :data="data6">
             <template slot-scope="{ row }" slot="status">
                <span v-if="row.status==1">{{$t('normal')}}</span>
                <span v-else>{{$t('lock')}}</span>
            </template>
            <template slot-scope="{ row }" slot="is_verified">
                <span v-if="row.is_verified==1">{{$t('already')}}</span>
                <span v-else>{{$t('no')}}</span>{{$t('userView.isVerified')}}
            </template>
            <template slot-scope="{ row }" slot="is_billing">
                <span v-if="row.is_billing==1">{{$t('already')}}</span>
                <span v-else>{{$t('no')}}</span>{{$t('userView.isBilling')}}
            </template>
            <template slot-scope="{ row }" slot="is_order">
                <span v-if="row.is_order==1">{{$t('already')}}</span>
                <span v-else>{{$t('no')}}</span>{{$t('userView.isOrder')}}
            </template>
            <template slot-scope="{ row }" slot="is_withdraw">
                <span v-if="row.is_withdraw==1">{{$t('already')}}</span>
                <span v-else>{{$t('no')}}</span>{{$t('userView.isWithdraw')}}
            </template>
            <template slot-scope="{ row }" slot="is_withdraw">
                <span v-if="row.is_withdraw==1">{{$t('already')}}</span>
                <span v-else>{{$t('no')}}</span>{{$t('userView.isWithdraw')}}
            </template>
            <template slot-scope="{ row }" slot="created_at">
                {{new Date(Date.parse(row.created_at)).toLocaleString()}}
            </template>

            <template slot-scope="{ row }" slot="action">
                <Button type="success" size="small" style="margin-right: 5px" @click="click_edit_pass(row.user_id)">{{$t('edit')}}{{$t('password')}}</Button>
                <Button
                    type="primary"
                    size="small"
                    style="margin-right: 5px"
                    @click="showUserDetail(row.user_id)"
                >{{$t('detail')}}</Button>
               <Button type="success" size="small" style="margin-right: 5px" @click="billing(row.user_id,row.is_billing)">
                   <span v-if = "row.is_billing==0">
                   {{$t('userView.isBilling')}}
                   </span>
                   <span v-else>
                   {{$t('no')}}{{$t('userView.isBilling')}}
                   </span>
                   </Button>

                <Button type="error" size="small" @click="lockUser(row.user_id,row.status)"><span v-if="row.status==1">{{$t('lock')}}</span><span v-else>{{$t('unlock')}}</span></Button>
            </template>
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
        <Modal v-model="show_add_user" :title="$t('add')+$t('user')" @on-ok="add_user">
            <Form :model="modalAdd" :label-width="100">
                <FormItem :label="$t('username')">
                    <Input v-model="modalAdd.mobile"></Input>
                </FormItem>
                <FormItem :label="$t('password')">
                    <Input type="password" v-model="modalAdd.pass"></Input>
                </FormItem>
            </Form>
        </Modal>
        <Modal v-model="show_edit_pass" :title="$t('edit')+$t('password')" @on-ok="edit_pass">
            <Form :model="modalEdit" :label-width="100">
                <FormItem :label="$t('password')">
                    <Input type="password" v-model="modalEdit.pass"></Input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>


<script>
export default {
    data() {
        return {
            showDelModal: false,
            userIdToDel: 0,
            currentPage: 1,
            totalItems: 0,
            totalPages: 1,
            totalItems: 1,
            itemsPerPage: 10,
            search: "",
            columns12: [
                {
                    title: "ID",
                    key: "user_id"
                },
                {
                    title: this.$i18n.t('mobile'),
                    key: "mobile"
                },
                {
                    title: this.$i18n.t('username'),
                    key: "real_name"
                },
                {
                    title: this.$i18n.t('status'),
                    key: "status",
                    slot:"status"
                },
                {
                    title: this.$i18n.t('time'),
                    key: "created_at",
                    slot:"created_at"
                },
                {
                    title: this.$i18n.t('userView.isVerified'),
                    key: "is_verified",
                    slot:"is_verified"
                },
                {
                    title: this.$i18n.t('userView.isBilling'),
                    key: "is_billing",
                    slot:"is_billing"
                }, 
                {
                    title: this.$i18n.t('userView.isOrder'),
                    key: "is_order",
                    slot:"is_order"
                },
                {
                    title: this.$i18n.t('userView.isWithdraw'),
                    key: "is_withdraw",
                    slot:"is_withdraw"
                },
                {
                    title: this.$i18n.t('userView.withdrawPassword'),
                    key: "safe_password",
                },
                {
                    title: this.$i18n.t('agent.agent'),
                    key: "agentName",
                },
                {
                    title: this.$i18n.t('agent.phoneKefu'),
                    key: "kefuName",
                },
                {
                    title: this.$i18n.t('action'),
                    slot: "action",
                    width: 380,
                    align: "center"
                }
            ],
            data6: [],
            modalAdd: {
                mobile: "",
                pass: ""
            },
            modalEdit:{
                user_id:'',
                pass:''
            },
            show_add_user: false,
            show_edit_pass:false
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            let path = this.search ? this.$path.user_search : this.$path.user;
            this.$get(path, {
                mobile: this.search,
                page: this.currentPage
            }).then(res => {
                if (res.data) {
                    this.data6 = res.data.list;
                    const that=this;
                   this.data6.forEach(function(item,index,arr){
                        try{
                            switch (item.vip_level) {
                                case 0:
                                    that.data6[index].vip_level=that.$i18n.t('userView.vip1');
                                    break;
                                case 1:
                                    that.data6[index].vip_level=that.$i18n.t('userView.vip2');
                                    break;
                                case 2:
                                    that.data6[index].vip_level=that.$i18n.t('userView.vip3');
                                    break;
                                default:
                                    that.data6[index].vip_level=that.$i18n.t('userView.nothing');
                            }
                        }catch(e){
                            console.log(e);
                        }
                    });
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        showUserDetail(user_id) {
            this.$router.push({
                name: "user_detail",
                query: {
                    user_id: user_id
                }
            });
        },
        lockUser(user_id,status) {
            if(!confirm(this.$i18n.t('confirm')+this.$i18n.t('lock'))){
                return false;
            }
            this.$post(this.$path.user_lock, {
                user_id: user_id,
                status:status
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        billing(id,val){
            if(!confirm(this.$i18n.t('confirm')+this.$i18n.t('userView.isBilling'))){
                return false;
            }
             this.$post(this.$path.user_billing, {
                id: id,
                val:val
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        delModal(user_id) {
            this.userIdToDel = user_id;
            this.showDelModal = true;
        },
        add_user() {
            this.$post(this.$path.user_add, this.modalAdd).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                    this.modalAdd = {
                        mobile:'',
                        pass:''
                    }
                }
            });
        },
        click_edit_pass(user_id){
            this.modalEdit.user_id = user_id;
            this.show_edit_pass = true;
        },
        change_vip_level(user_id,vip_level){
            this.$post(this.$path.change_vip_level, {user_id:user_id,vip_level:vip_level}).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        edit_pass(){
            this.$post(this.$path.restpass, this.modalEdit).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                    this.modalEdit.pass = '';
                }
            });
        }
    }
};
</script>


<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
    .add_user {
        float: right;
    }
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/user/user.vue